@if (goal === 'reset') {
  <h2>Wachtwoord resetten</h2>
}
@if (goal === 'reset') {
  <p>Vul onderstaand formulier in om je wachtwoord te resetten.@if (!gotToken) {
    <span> Als het token-veld nog niet ingevuld is, kun je het token vinden in de email die je hier bracht.</span>
  }</p>
}
@if (goal === 'confirm') {
  <h2>E-mailadres bevestigen</h2>
}
@if (goal === 'confirm') {
  <p></p>
}
<br>
  @if (errorMessage) {
    <div class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>
  }

  <div fxLayout="row" fxLayoutAlign="start start" class="confirmform">
    <div fxFlex="50%" fxFlex.lt-sm="100%">
      <!-- Email-->
      <mat-form-field>
        <input matInput placeholder="E-mailadres" name="email" type="email" [(ngModel)]="email" [disabled]="gotEmail">
      </mat-form-field>
    </div>
  </div>
  @if (!gotToken) {
    <div fxLayout="row" fxLayoutAlign="start start" class="confirmform">
      <div fxFlex="50%" fxFlex.lt-sm="100%">
        <!-- Token-->
        <mat-form-field>
          <input matInput placeholder="Token" name="token" [(ngModel)]="token">
        </mat-form-field>
      </div>
    </div>
  }
  <div fxLayout="row" fxLayoutAlign="start start" class="confirmform">
    <div fxFlex="50%" fxFlex.lt-sm="100%">
      <!-- Password 1-->
      <mat-form-field>
        <input matInput type="password" placeholder="Wachtwoord" name="password" [(ngModel)]="password">
      </mat-form-field>
    </div>
    <div fxFlex="50%" fxFlex.lt-sm="100%">
      <!-- Password 2-->
      <mat-form-field>
        <input matInput type="password" placeholder="Herhaal wachtwoord" name="password2" [(ngModel)]="password2">
        @if (password.length >= 6 && password2.length >= 6 && password !== password2) {
          <mat-hint>De wachtwoorden zijn niet gelijk</mat-hint>
        }
        @if (password === password2 && password.length < 6 && password.length > 0) {
          <mat-hint>Wachtwoord moet minimaal bestaan uit 6 letters of nummers</mat-hint>
        }
      </mat-form-field>
    </div>
  </div>
  <button mat-raised-button (click)="confirm()" color="primary" [disabled]="password !== password2 || password.length < 6">Verstuur</button>
